import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-service-dialog',
  templateUrl: './customer-service-dialog.component.html',
  styleUrls: ['./customer-service-dialog.component.scss']
})
export class CustomerServiceDialogComponent {

}
